module.exports = __webpack_public_path__ + "img/virtual_fan_2.6cfa062.jpg";